var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0419922 20.7501L11.5003 0.166748L22.9587 20.7501H0.0419922ZM2.75033 19.1251H20.2503L11.5003 3.41675L2.75033 19.1251ZM11.6045 17.5813C11.8302 17.5813 12.0168 17.5046 12.1644 17.3511C12.312 17.1976 12.3857 17.0036 12.3857 16.7688C12.3857 16.5341 12.312 16.34 12.1644 16.1865C12.0168 16.0331 11.8302 15.9563 11.6045 15.9563C11.3788 15.9563 11.1922 16.0331 11.0446 16.1865C10.897 16.34 10.8232 16.5341 10.8232 16.7688C10.8232 17.0036 10.897 17.1976 11.0446 17.3511C11.1922 17.5046 11.3788 17.5813 11.6045 17.5813ZM10.8232 14.5751H12.3857V8.50841H10.8232V14.5751Z",
    fill: "#D03434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e7036d5479818288eb937e77ede4e670.svg";
export { ForwardRef as ReactComponent };